import { RequestMethod } from "../types/api/RequestMethod";
import { ALERTS, FETCH } from "./constants";

type ValidationErrors = {
  [key: string]: string[];
};

export const getAuthToken = (): string => {
  const oktaTokenStorage: string = localStorage.getItem("okta-token-storage") ?? "";
  if (!oktaTokenStorage) {
    return "";
  }
  const parsed: {
    accessToken: {
      accessToken: string;
    };
    idToken: string;
  } = JSON.parse(oktaTokenStorage);
  return parsed.accessToken.accessToken;
};

const processValidationErrors = (errors: ValidationErrors[]) => {
  /**
   * cb_pos only returns an 'errors' key in a specific json structure if there are
   * model validation errors that the request payload did not comply with
   */
  const errorsStr: string = errors.reduce((acc: string, cur: ValidationErrors) => {
    Object.entries(cur).forEach(([key, errListForProperty]) => {
      acc += `${key}: ${errListForProperty.join(", ")}. `;
    });
    return acc;
  }, "");
  throw new Error(errorsStr);
};

export const fetchFunction = async (
  endpoint: string,
  { method = RequestMethod.GET, body = {} } = {}
) => {
  const headers = {
    Authorization: `Bearer ${getAuthToken()}`,
    [FETCH.CONTENT_TYPE.VALUE]: FETCH.CONTENT_TYPE.JSON,
  };

  const fetchBody = method !== RequestMethod.GET ? JSON.stringify(body) : undefined;

  const response = await fetch(endpoint, {
    method,
    headers,
    ...(fetchBody && { body: fetchBody }),
  });

  if (!response.ok) {
    const contentType = response.headers.get(FETCH.CONTENT_TYPE.VALUE);
    if (contentType && !contentType.includes(FETCH.CONTENT_TYPE.JSON)) {
      // cb_pos should only be returning JSON from requests. if it doesn't, fallback to a generic network error message
      throw new Error(ALERTS.ERRORS.NETWORK_ERROR);
    }

    const errText = await response.text();
    const err = errText ? JSON.parse(errText) : {};

    if (Object.prototype.hasOwnProperty.call(err, "errors")) {
      processValidationErrors(err.errors);
    }

    throw new Error(err.message || ALERTS.ERRORS.NETWORK_ERROR);
  }

  return response.json();
};
